import { mapState, mapGetters } from 'vuex';

export default {
  name: 'dataLayerPushAdmissionMixin',

  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit
    }),

    ...mapGetters(['getBrandUnitIdVariables'])
  },

  methods: {
    /**
     * @method dataLayerPushData
     * @param {string} eligible
     * @description Data layer event for analytics
     */
    dataLayerPushAdmission(eligible) {
      const { id } = this.currentAdmission;
      const brandId = this.getBrandUnitIdVariables.brandId;

      /* eslint-disable */
      dataLayer.push({
        event: 'dados-admissao',
        admissionId: id || null,
        unidade: `${this.selectedUnit?.idUnidade}-${this.selectedUnit?.nome}` || null,
        marca: brandId,
      });
    }
  }
}
